import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
let wilburk = false;
const FilterBar = ({
  models,
  casas,
  onFilter,
  filters,
  filteredData,
  reset,
  // onCodiceFilter,
  // onOeFilter,
  // onModalFilter,
  // onBrandFilter,
}) => {
  // const [filters, setFilters] = useState({
  //   codice: "",
  //   modal: "",
  //   oe: "",
  //   casa: "",
  // });

  const handleInput = (field) => (event) => {
    const { value } = event.target;
    // onFilter
    //     setFilters({
    //       ...filters,
    //       [field]: value,
    //     });

    return onFilter(value, field);

    // switch (field) {
    //   case "codice":
    //     onCodiceFilter(value);
    //     break;
    //   case "oe":
    //     onOeFilter(value);
    //     break;
    //   case "modal":
    //     onModalFilter(value);
    //     break;
    //   case "casa":
    //     onBrandFilter(value);
    //     break;
    //   default:
    //     break;
    // }
  };

  // console.log(filters);

  return (
    <>
      <Form className="m-3 ">
        <Row
          className="catalogo-filterbar"
          style={{ backgroundColor: !wilburk ? "" : "#e0001a" }}
        >
          <Col>
            <Form.Control
              type="text"
              className="form-control mb-4 mt-3 mt-sm-4"
              id="codice"
              value={filters?.codice || ""}
              placeholder="Codice"
              onChange={handleInput("codice")}
            />
          </Col>
          <Col>
            <Form.Control
              type="text"
              className="form-control mb-4 mt-3 mt-sm-4"
              id="oe"
              placeholder="OE"
              value={filters?.oe || ""}
              onChange={handleInput("oe")}
            />
          </Col>
          <Col>
            <Form.Control
              type="text"
              className="form-control mb-4 mt-3 mt-sm-4"
              id="Competitors"
              placeholder="Competitors"
              value={filters?.competitors || ""}
              onChange={handleInput("competitors")}
            />
          </Col>
          <Col>
            <Form.Select
              aria-label="Default select example"
              className="form-control mb-4 mt-sm-4 mt-3"
              id="casa"
              value={filters?.casa || ""}
              onChange={handleInput("casa")}
            >
              {filters?.casa ? (
                <option value="">Reset Brand ↩</option>
              ) : (
                <option value="">Brand</option>
              )}

              {casas &&
                casas?.map((casa) => {
                  let youShallPass = false;

                  if (filteredData && filteredData.length) {
                    filteredData.forEach((item) => {
                      if (item.Casa === casa) {
                        youShallPass = true;
                      }
                    });
                  } else {
                    youShallPass = true;
                  }

                  if (youShallPass) {
                    return (
                      <option value={casa} key={casa}>
                        {casa}
                      </option>
                    );
                  } else {
                    return null;
                  }
                })}
            </Form.Select>
          </Col>
          <Col>
            <Form.Select
              aria-label="Default select example"
              className="form-control mb-4 mt-3 mt-sm-4"
              id="modal"
              value={filters?.model || ""}
              onChange={handleInput("model")}
            >
              {filters?.model ? (
                <option value="">Reset Model ↩</option>
              ) : (
                <option value="">Model</option>
              )}
              {models &&
                models?.map((model) => {
                  let youShallPass = false;

                  if (filteredData && filteredData.length) {
                    filteredData.forEach((item) => {
                      if (item.Modello === model) {
                        youShallPass = true;
                      }
                    });
                  } else {
                    youShallPass = true;
                  }

                  if (youShallPass) {
                    return (
                      <option value={model} key={model}>
                        {model}
                      </option>
                    );
                  } else {
                    return null;
                  }
                })}
            </Form.Select>
          </Col>
          <Col style={{ width: "auto", flex: 0 }}>
            <button
              className="resetButton"
              style={{ margin: 0 }}
              onClick={() => {
                reset();
              }}
            >
              Reset
            </button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FilterBar;
